export default __webpack_public_path__ + "static/media/cfdWorkIcon3.ba09de9c.webp";